<template>
    <v-container>
        <h3 v-if="!hide.dom">{{$t('webboxes.styling.global.placement')}}</h3>
            <v-row  no-gutters  v-if="!hide.dom">
            <v-col class="mr-3">
            <v-select :value="domMode" @input="$emit('update:domMode', $event)" :items="mode" :label="$t('webboxes.styling.global.insertionMode')"/>
            </v-col>
            <v-col class="ml-3">
                <!--  prepend-icon="$hash" -->
            <v-text-field id="pfid1618818044" :value="domId" @input="$emit('update:domId', $event)" :label="$t('webboxes.styling.global.targetId')"
                class="pr-3" />
            </v-col>
            </v-row>
            <h3>{{$t('webboxes.styling.global.appearance')}}</h3>
            <v-text-field id="pfid1651761751"  :value="titleContent" @input="$emit('update:titleContent', $event)" :label="$t('webboxes.styling.global.titleContent')"
                class="pr-3" clearable />
            <v-text-field id="pfid1651761840"   :value="titleTag" @input="$emit('update:titleTag', $event)" :label="$t('webboxes.styling.global.titleTag')"
                class="pr-3" clearable />
            <v-text-field id="pfid1660914166"  :value="titleClass" @input="$emit('update:titleClass', $event)" :label="$t('webboxes.styling.global.titleClass')"
                class="pr-3" clearable />
            
            <label class="v-label d-block mt-5">{{$t('webboxes.styling.global.cardWidth')}}</label>
            <v-slider id="pfid1618818056" 
                v-model.number="cardWidthInt"
                :disabled="customSplideConfig"
                thumb-size="24"
                :thumb-label="true"
                min="0"
                max="500"
                hide-details
                class="align-center pr-3"
                >
                <template v-slot:prepend>
                <v-text-field
                v-model.number="cardWidthInt"
                min="0"
                max="500"
                class="mt-0 pt-0"
                hide-details
                single-line
                suffix="px"
                type="number"
                style="width: 80px"
              ></v-text-field>
            </template>
            </v-slider>

            <label class="v-label d-block mt-5">{{$t('webboxes.styling.global.gap')}}</label>
            <v-slider
                id="pfid1618818094" 
                v-model.number="gapInt"
                :disabled="customSplideConfig"
                thumb-size="24"
                :thumb-label="true"
                min="0"
                max="100"
                hide-details
                class="align-center pr-3"
                
                >
                <template v-slot:prepend>
                <v-text-field
                v-model.number="gapInt"
                min="0"
                max="100"
                class="mt-0 pt-0"
                hide-details
                single-line
                suffix="px"
                type="number"
                style="width: 80px"
              ></v-text-field>
            </template>
            </v-slider>
            <h3 class="mt-5">{{$t('webboxes.styling.global.behavior')}}</h3>
            <v-switch
                id="pfid1618818126" 
                :value="newTab" @change="$emit('update:newTab', $event)"
                :label="$t('webboxes.styling.global.newTab')"
                class="pr-3"
            />
            <h3 class="mt-5">{{$t('webboxes.styling.global.utm.title')}}</h3>
            <v-text-field id="pfid1618818132" :value="utmCampaign" @input="$emit('update:utmCampaign', $event)" :label="$t('webboxes.styling.global.utm.campaign')"
                class="pr-3" />
            <template v-if="!hide.code">
            <h3>{{$t('webboxes.styling.global.custom.title')}}</h3>
            <v-switch
                id="pfid1618818143" 
                :value="customCardStyle" @change="$emit('update:customCardStyle', $event)"
                :label="$t('webboxes.styling.global.custom.style')"
                class="pr-3"
            />
            <v-switch
                id="pfid1618818148" 
                :value="customArrowStyle" @change="$emit('update:customArrowStyle', $event)"
                :label="$t('webboxes.styling.global.custom.arrows')"
                class="pr-3"
            />
            <v-switch
                id="pfid1618818153" 
                :value="customSplideConfig" @change="$emit('update:customSplideConfig', $event)"
                :label="$t('webboxes.styling.global.custom.splide')"
                class="pr-3"
           />
            </template>
    </v-container>
</template>
<script>
export default {
    name: 'GlobalStyling',
    props: { 
        domMode: String, 
        domId: String, 
        cardWidth: { type: Number, default: 200 }, 
        gap: {type: Number, default: 20 }, 
        newTab: Boolean, 
        utmCampaign: String, 
        customCardStyle: Boolean, 
        customArrowStyle: Boolean, 
        customSplideConfig: Boolean, 
        titleContent: String, 
        titleTag: { type: String, default: 'h2' },
        titleClass: String, 
        hide: { type: Object, default: () => ({}) } 
    },
    data() {
        return {
            mode: [ {text: this.$t('webboxes.styling.global.after'), value: 'AFTER'},{text: this.$t('webboxes.styling.global.before'), value: 'BEFORE'}, {text: this.$t('webboxes.styling.global.into'), value: 'INTO'} ],
        }
    },
    watch: {
    },
    computed: {
        // required so we can use the v-model.number modifier
        cardWidthInt: {
            get() {
                return this.cardWidth || 200;
            },
            set(val) {
                this.$emit('update:cardWidth', val);
            }
        },
        gapInt: {
            get() {
                return this.gap || 20;
            },
            set(val) {
                this.$emit('update:gap', val);
            }
        }
    },
    methods: {
    }
}
</script>